import { Icd9Code, Icd9Name } from '@dreryk/egabinet-icd-dictionary-published-language-api';

import { convertLocalDateTimeToDate } from '@dreryk/react-common';

import { MedicalImagingEntryFormBean } from '~legacy.patient';

import { VisitMedicalImgaingCreateParameters } from './AddMedicalImagingLink.types';

export const mapMedicalImagingEntryFormBeanParametersToVisitMedicalImagingCreateParameters = (
   parameters: MedicalImagingEntryFormBean,
   medicalInformationId: number
): VisitMedicalImgaingCreateParameters => ({
   description: parameters.description,
   examinationDate: convertLocalDateTimeToDate(parameters.examinationDate.atTime(parameters.examinationTime)),
   icd9Code: Icd9Code.of(parameters.icd9Procedure.code),
   icd9Name: Icd9Name.of(parameters.icd9Procedure.name),
   medicalInformationId: medicalInformationId,
});
